const state = () => ({
  user: null,
  isLogined: false
});

const mutations = {
  SET_USER(state, user) {
    // console.log("SET_USER");
    // console.log(user);
    if (user) delete user.password;
    state.user = user || null;
  },
  SET_USER_CASH(state, cash) {
    if (state.user) {
      state.user.cash = cash;
      state.user.cash.sportsmoney = cash.sportsmoney;
    }
  },
  SET_ISLOGINED(state, val) {
    state.isLogined = val;
  }
};

const getters = {
  isAuthenticated(state) {
    return !!state.user;
  },
  currentUser(state) {
    return state.user || null;
  },
  getIsLogined(state) {
    return state.isLogined;
  }
};

const actions = {
  logout({ state }) {
    // 로그아웃하는 함수
    if (!state.user) {
      return;
    }
    return;
    // return feathers.logout()
    //   .then((res) => {
    //     commit('SET_USER', null);
    //     commit('SET_ISLOGINED', false);
    //     this.$router.push('/')
    //   })
    //   .catch((err) => { // console.log(err) })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
